import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { ICountry } from "./countries.interface";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class CountriesService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getCountries(filter?: any): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_COUNTRIES)}${queryParams}`);
  }

  getCountry(country: ICountry | string): Observable<any> {
    let id = (typeof country == 'string') ? country : country._id;
    return this._http.get(`${apiURL(EnvConfig.API_COUNTRIES)}/${id}`);
  }

  createCountry(country: ICountry): Observable<any> {
    delete country._id;
    return this._http.post(`${apiURL(EnvConfig.API_COUNTRIES)}`, country);
  }

  updateCountry(country: ICountry): Observable<any> {
    let id = country._id;
    delete country._id;
    return this._http.patch(`${apiURL(EnvConfig.API_COUNTRIES)}/${id}`, country);
  }

  deleteCountry(country: ICountry | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof country == 'string') ? country : country._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_COUNTRIES)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_COUNTRIES)}/${id}/delete`);
  }

  restoreCountry(country: ICountry | string): Observable<void> {
    let id = (typeof country == 'string') ? country : country._id;
    return this._http.patch(`${apiURL(EnvConfig.API_COUNTRIES)}/${id}/restore`, null);
  }
}